var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['flex-shrink-0 relative flex cursor-pointer transition-main mouse-device:hover:opacity-80'],attrs:{"href":"/"}},[_c('LogoIcon',{class:{
            'fill-current flex-shrink-0': true,
            'text-white': _vm.theme === 'white',
            'text-black': _vm.theme === 'black',
            'max-w-[177px] screen-320:max-w-[165px]': _vm.size === 'base',
            'max-w-[164px] md:max-w-[148px]': _vm.size === 'sm'
        }}),_vm._v(" "),_c('Transition',{attrs:{"name":"fade"}},[(_vm.userType === _vm.userTypesEnum.company)?_c('span',{key:_vm.userType,staticClass:"absolute -bottom-2.5 font-stolzl font-normal text-xs"},[_vm._v(".бизнес")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }